import { useEffect } from 'react';
const PIXEL_ID = '1427507205888110';
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[];
      push?: unknown;
      loaded?: boolean;
      version?: string;
    };
    _fbq?: unknown;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    const fbq: Window['fbq'] = function (...args: unknown[]) {
      if (fbq!.callMethod) {
        fbq!.callMethod.apply(fbq, args);
      } else {
        fbq!.queue!.push(args);
      }
    } as Window['fbq'];
    window.fbq = fbq;
    window._fbq = fbq;
    fbq!.push = fbq;
    fbq!.loaded = true;
    fbq!.version = '2.0';
    fbq!.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
    const noscript = document.createElement('noscript');
    const pixelImage = document.createElement('img');
    pixelImage.height = 1;
    pixelImage.width = 1;
    pixelImage.style.display = 'none';
    pixelImage.alt = '';
    pixelImage.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(pixelImage);
    document.body.appendChild(noscript);
  }, []);
  return null;
}